import { schema } from "normalizr"

export default new schema.Object({
  idAttribute: "userId",
})
